module.exports = __webpack_public_path__ + "static/media/user-6.657a6057.jpg";